import GroupedContentsTab from "./GroupedContentsTab";

export default function CompleteTab({ list }) {
  return <GroupedContentsTab list={list} />;
}
